import get from 'lodash/get';

import {getIdAndMultiName, getMultiName, getNameAndLink} from "helpers/mappers";

export const ServiceRegister = (item) => ({
    id: get(item, 'id') || '',
    uniqueNumber: get(item, 'service_number') || '',
    serviceName: getMultiName(get(item, 'service_name')),
    organization: getIdAndMultiName(get(item, 'organization')),
    addition: (get(item, 'addition') || []).map(value => getMultiName(value)),
    organizations: (get(item, 'organizations') || []).map(value => getIdAndMultiName(value)),
    usersType: get(item, 'users_type') || '',
    subjectType: get(item, 'subject_type') || '',
    serviceForm: get(item, 'service_form') || '',
    paymentType: get(item, 'payment_type') || '',
    serviceResult: get(item, 'service_result') || '',
    withPayment: get(item, 'payment_info') || [],
    serviceDocument: get(item, 'service_document') || '',
    principles: get(item, 'principles') || [],
    requirements: get(item, 'requirements') || [],
    informationSystems: (get(item, 'information_systems') || []).map(value => getNameAndLink(value)),
    validityPeriod: {
        id: get(item, 'validity_period.id') || '',
        status: get(item, 'validity_period.status') || '',
        type: get(item, 'validity_period.type') || '',
        value: get(item, 'validity_period.value') || '',
    },
    payments: (get(item, 'payments') || []).map(value => ({
        id: get(value, 'id') || '',
        payment_value: get(value, 'payment_value') || 0,
        percent: get(value, 'percent') || 0,
        name: get(value, 'name') || '',
        type: get(value, 'type') || '',
    })),
});